import Audio from './resourceaudio'
export default Audio
